import { computed, type Ref } from 'vue';
import { useQuery } from '@vue/apollo-composable';
import { GET_STUDENT_PROFILE_FIELD_SETTINGS } from '@/graphql/studentProfileForm';
import type { StudentProfileFieldSettingsQuery, StudentProfileFieldSettingsQueryVariables } from '@/types/operations';

/** The built-in fields students may fill in on their profile (needs Custom Fields → View). */
export function useStudentProfileFieldSettings(options: { enabled?: Ref<boolean> } = {}) {
  const { result, loading, error, refetch } = useQuery<StudentProfileFieldSettingsQuery, StudentProfileFieldSettingsQueryVariables>(
    GET_STUDENT_PROFILE_FIELD_SETTINGS,
    {},
    () => ({ fetchPolicy: 'cache-and-network', enabled: options.enabled?.value ?? true }),
  );

  return {
    settings: computed(() => result.value?.studentProfileFieldSettings ?? []),
    loading,
    error,
    refetch,
  };
}
